import { httpRequest } from "@services/http";
import { PopulationList } from "@models/population.model";

export class CommandGetPopulation {
  async run(
    launchId: number,
    limit: number = 50,
    offset: number = 0,
    audienceId: number | null = null,
    consumerId: number | null = null,
    controlMode: string | null = null,
  ): Promise<PopulationList> {
    let url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/population/?limit=${limit}&offset=${offset}`;
    if (audienceId !== null && audienceId !== undefined) {
      url += `&audience_id=${audienceId}`;
    }
    if (consumerId !== null && consumerId !== undefined) {
      url += `&consumer_id=${consumerId}`;
    }
    if (controlMode !== null && controlMode !== undefined) {
      url += `&control_mode=${controlMode}`;
    }
    return await httpRequest<PopulationList>(url, { method: "GET", cache: "no-store" });
  }
}
